import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ChartOptions,
  ChartData,
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Card, Button, Modal, Form, Input, notification } from "antd";
import { logout } from "../redux/slice/userslice";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AiOutlineUser } from "react-icons/ai";
import { GET, POST, PUT } from "../utils/apicalls";
import { API } from "../config/api";
import './admindashboard.css'
ChartJS.register(BarElement, CategoryScale, LinearScale, Title, Tooltip, Legend);

const AdminDashboard: React.FC = () => {
  const UserIcon = AiOutlineUser as unknown as React.FC<{ size?: number; color?: string }>;
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [data, setData] = useState<any>([]);
  const [countdata, setcountData] = useState<any>([]);
  const [isLoading, setIsLoading] = useState(false);
  const user = useSelector((state: any) => state.user);
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleLogout = () => {
    dispatch(logout());
    navigate("/admin");
  };

  const currentYear = new Date().getFullYear();
  const [selectedYear, setSelectedYear] = useState<number>(currentYear);
  const [chartData, setChartData] = useState<ChartData<"bar"> | null>(null);

  const options: ChartOptions<"bar"> = {
    responsive: true,
    indexAxis: "y",
    plugins: {
      legend: { display: true },
      title: { display: true, text: `Monthly Data (${selectedYear})` },
    },
    scales: {
      x: {
        ticks: {
          stepSize: 3, // Ensures x-axis values increase by 5
        },
        suggestedMin: 0, // Ensures the x-axis starts at 0
        suggestedMax: undefined, // Allows automatic adjustment
      },
    },
  };

  const fetchBookingData = async () => {
    try {
      const url = API.FILTERYEAR_BOOKING_DATA;
      const response: any = await POST(url, { year: selectedYear });
      if (response?.data) {
        // Initialize all months with zero
        const months = [
          "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"
        ];
        const monthlyData: { [key: string]: number } = months.reduce((acc, month) => {
          acc[month] = 0;
          return acc;
        }, {} as { [key: string]: number });

        response.data.forEach((item: any) => {
          const month = new Date(item.orderdate).toLocaleString("default", { month: "long" });
          if (monthlyData[month] !== undefined) {
            monthlyData[month] += 1;
          }
        });

        setChartData({
          labels: months,
          datasets: [
            {
              label: "Total Items",
              data: months.map(month => monthlyData[month]),
              backgroundColor: "rgba(255, 99, 132, 0.6)",
              borderColor: "rgba(255, 99, 132, 1)",
              borderWidth: 1,
            },
          ],
        });
      }
    } catch (error) {
      console.error("Error fetching booking data:", error);
    }
  };

  useEffect(() => {
    fetchBookingData();
  }, [selectedYear]);



  const UpdateHandler = async (values: any) => {
    try {
      let obj = {
        adminUsername: values.adminUsername,
        adminpassword: values.adminpassword,
        adminphone_number: values.adminphone_number,
        type: "admin"
      };

      setIsLoading(true);
      let api = API.UPDATE_ADMIN + user.id;
      const postRequest: any = await PUT(api, obj);
      if (postRequest.status) {
        notification.success({ message: " updated successfully!" });
        form.resetFields();
        fetchOneadmin();
        setIsModalOpen(false)
      } else {
        notification.error({ message: "Something went wrong" });
      }
    } catch (error) {
      console.error(error);
      notification.error({
        message: "Something went wrong! Please try again later",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const fetchOneadmin = async () => {
    try {
      setIsLoading(true);
      let api = API.FIND_ONE_ADMIN + user.id;
      const response: any = await GET(api, {});
      setData(response?.data);
      form.setFieldsValue(response?.data);

    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchOneadmin();
  }, []);

  const countalldata = async () => {
    try {
      setIsLoading(true);
      const response: any = await GET(API.COUNT_ALL_DATA, {});
      setcountData(response?.data || []);
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    countalldata();
  }, []);
  return (
    <div className="admindasboard">
      <Card className="admin-dashboard">
        <div className="dashboard-container">
          <h2>ADMIN DASHBOARD</h2>
          <div className="admin-actions">
            {user.isAuthenticated ? (

              <Button onClick={handleLogout}>Logout</Button>


            ) : (
              <h1>Please log in</h1>
            )}
            <div onClick={() => setIsModalOpen(true)} style={{ cursor: "pointer" }}>
              <UserIcon size={30} color="white" />
            </div>

          </div>
        </div>
      </Card>



      <div className="stats-container">
        <div>Total number of Partners <br /> {countdata.clientdata}</div>
        <div>Total number of Products <br />{countdata.product}</div>
        <div>Total number of Categories<br /> {countdata.categorys}</div>
        <div>Total number of Bookings  <br /> {countdata.bookingData}</div>
      </div>

      <div>
        <h3 className="mt-5">Booking Data ({selectedYear})</h3>
        <label>Select Year: </label>
        <select value={selectedYear} onChange={(e) => setSelectedYear(Number(e.target.value))}>
          {Array.from({ length: 5 }, (_, i) => (
            <option key={i} value={currentYear - i}>
              {currentYear - i}
            </option>
          ))}
        </select>
        {chartData ? <Bar data={chartData} options={options} /> : <p>Loading chart data...</p>}
      </div>

      <Modal
        title="update admin details"
        visible={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        footer={null}
        width="90%"
      >
        <Form form={form} onFinish={UpdateHandler} layout="vertical">
          <Form.Item
            name="type"
            label="type"
            rules={[{ required: true }]}
          >
            <Input disabled />
          </Form.Item>
          <Form.Item
            name="adminUsername"
            label="adminUsername"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="adminpassword"
            label="adminpassword"
            rules={[{ required: true }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="adminphone_number"
            label="adminphone_number"
            rules={[{ required: true }]}
          >
            <Input.TextArea />
          </Form.Item>

          <Button type="primary" htmlType="submit" block>
            Submit
          </Button>
        </Form>
      </Modal>
    </div>
  );
};

export default AdminDashboard;